import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { staffIsAdmin } from '../../utils/staffIsAdmin'
import ReactPaginate from "react-paginate";
const $ = require("jquery")
$.Datatable = require("datatables.net");



export default function Cancelled() {
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    if (nodeMode === "development") {
      var baseUrl = beckendLocalApiUrl;
    } else {
      baseUrl = beckendLiveApiUrl;
    }

    const [challenge, setchallenge] = useState()
    const canDeleteHistory = staffIsAdmin()
    
    //use for pagination..
    let [limit,setLimit] = useState(10);

    const setpageLimit = (event)=>{
      let key = event.target.value
      setLimit(key);
  }
    const [pageNumber, setPageNumber] = useState(0);
    const [numberOfPages, setNumberOfPages] = useState(0);

    //react paginate..
    const handlePageClick = async (data) => {
        let currentPage = data.selected + 1;
        setPageNumber(currentPage);
        // scroll to the top
        //window.scrollTo(0, 0)
      };
      
    const Allchallenge = async () => {
        const access_token = localStorage.getItem('token')
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.get(baseUrl+`challange/cancelled_challange?page=${pageNumber}&_limit=${limit}`, { headers })
            .then((res) => {
                setchallenge(res.data.status)
                setNumberOfPages(res.data.totalPages)
                //$('table').dataTable();
            })
    }

    const isDeleteBlockedStatus = (s) => {
        const x = String(s || '').toLowerCase()
        return x === 'running' || x === 'pending' || x === 'conflict'
    }

    const deleteChallenge = async (game) => {
        if (!game || isDeleteBlockedStatus(game.Status)) {
            alert('running / pending / conflict delete nahi ho sakti.')
            return
        }
        if (!window.confirm('Sirf history delete hogi — koi refund / balance change nahi.')) return
        const access_token = localStorage.getItem('token')
        const headers = { Authorization: `Bearer ${access_token}` }
        try {
            await axios.delete(baseUrl + `admin/challange/${game._id}`, { headers })
            Allchallenge()
        } catch (e) {
            alert(e.response?.data?.msg || e.message || 'Delete failed')
        }
    }

    const bulkDeleteAllCancelled = async () => {
        if (!window.confirm('Saari cancelled challenges DB se delete? (is page se related sab)')) return
        const access_token = localStorage.getItem('token')
        const headers = { Authorization: `Bearer ${access_token}` }
        try {
            const res = await axios.post(baseUrl + 'admin/challange/bulk-delete', { status: 'cancelled' }, { headers })
            alert(`Deleted ${res.data.deletedCount ?? 0} cancelled record(s).`)
            Allchallenge()
        } catch (e) {
            alert(e.response?.data?.msg || e.message || 'Bulk delete failed')
        }
    }

    const CancelGame = async (id) => {
        const confirm = window.confirm("are you sure to cancel")

        if (confirm == true) {
            const access_token = localStorage.getItem('token')
            const headers = {
                Authorization: `Bearer ${access_token}`

            }
            axios.patch(baseUrl+`challange/Cancel/${id}`, { Cancelled_by: access_token }, { headers })
                .then((res) => {
                    Allchallenge()
                })
        }
        else {
            window.alert("sorry try again")
        }
    }
    const dateFormat=(e)=>{
      
  const date = new Date(e); 
const newDate = date.toLocaleString('default', { month: 'long',day:'numeric',hour:'numeric',hour12:true,minute:'numeric' });
return newDate;
  }

    useEffect(() => {
        Allchallenge()
    },[pageNumber,limit])

    if (challenge == undefined) {
        return null
    }

    return (
        <>
            {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
            <div className="row ">
                <div className="col-12 grid-margin">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">CANCELLED CHALLANGES</h4>
                            {canDeleteHistory && (
                            <div className="mb-3">
                                <button type="button" className="btn btn-sm btn-outline-danger" onClick={bulkDeleteAllCancelled}>
                                    Delete all cancelled (entire DB)
                                </button>
                                <span className="small text-muted ml-2">Har row par bhi Delete hai.</span>
                            </div>
                            )}
                            <select  className="form-control col-sm-1 m-1" id='pagelimit' name='pagelimit' onChange={setpageLimit}>
                                <option value="10">Set limit</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                            </select>
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th> ID</th>
                                            <th> Creator</th>
                                            <th> Accepter</th>
                                            <th> Amount </th>
                                            <th> Status </th>
                                            <th> Game Type </th>
                                            <th>Date</th>
                                            <th> Action </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {challenge && challenge.map((game, key) => (
                                            <tr key={key}>
                                                <td>{key + 1}</td>
                                                <td>{game._id}</td>
                                                <td>
                                                    <span className="pl-2 ">{game.Created_by?.Name ?? '—'}</span>
                                                </td>
                                                
                                                <td>
                                                    <span className="pl-2">{game.Accepetd_By?game.Accepetd_By.Name:null}</span>
                                                </td>
                                                <td>{game.Game_Ammount}</td>
                                                <td className='text-primary font-weight-bold'>{game.Status}</td>
                                                <td>{game.Game_type}</td>
                                                <td>{dateFormat(game.createdAt).split(',')[0]} </td>
                                                <td className="text-nowrap">
                                                    <Link type='button' className="btn btn-primary btn-sm mx-1" to={`/view/${game._id}`}>View</Link>
                                                    {canDeleteHistory && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger mx-1"
                                                        disabled={isDeleteBlockedStatus(game.Status)}
                                                        title={isDeleteBlockedStatus(game.Status) ? 'running/pending/conflict delete blocked' : 'Delete history'}
                                                        onClick={() => deleteChallenge(game)}
                                                    >
                                                        Delete
                                                    </button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            
                            <div className='mt-4'>
                            <ReactPaginate
                                previousLabel={"Previous"}
                                nextLabel={"Next"}
                                breakLabel={"..."}
                                pageCount={numberOfPages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={3}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination justify-content-center"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                                previousClassName={"page-item"}
                                previousLinkClassName={"page-link"}
                                nextClassName={"page-item"}
                                nextLinkClassName={"page-link"}
                                breakClassName={"page-item"}
                                breakLinkClassName={"page-link"}
                                activeClassName={"active"}
                            />
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
